import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import AuthProviderWithNavigate from './AuthProviderWithNavigate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename="/app">
        <AuthProviderWithNavigate>
            <App />
        </AuthProviderWithNavigate>
    </BrowserRouter>
);
reportWebVitals();